export interface IElevenLabsVars {
  modelId: string;
  voiceIdsTitle: string[];
  voiceIdsDefinition: string[];
  voiceIdsUsageNotes: string[];
  voiceIdsExamples: string[];
}

export const elevenLabsVars: IElevenLabsVars = {
  modelId: 'eleven_turbo_v2_5',

  // use below links to find the voice id
  // // https://elevenlabs.io/app/voice-library?voiceId=
  voiceIdsTitle: [
    // Caty - Droll, Wry and Dry
    '54Cze5LrTSyLgbO6Fhlc',
  ],

  voiceIdsDefinition: [
    // Peter
    'ZthjuvLPty3kTMaNKVKb',
    // Adam - American, Dark and Tough
    'IRHApOXLvnW57QJPQH2P',
    // Ian Cartwell - Suspense and Mystery
    'e5WNhrdI30aXpS2RSGm1',
    // Declan Sage - Wise and Captivating
    'kqVT88a5QfII1HNAEPTJ',
    // Knox Dark - Serious, Deep, and Steady
    'dPah2VEoifKnZT37774q',
    // Clyde - Full, Diplomatic and Inviting
    'wyWA56cQNU2KqUW4eCsI',
  ],

  voiceIdsUsageNotes: [
    // Serena – Gentle Coach and Wellness Guide
    'RGb96Dcl0k5eVje8EBch',
    // Sienna - Natural and Bright
    'uTof433lKWylEy1elPTY',
    // Ember - Energetic, Confident Protagonist
    'WtA85syCrJwasGeHGH2p',
    // Jessa - Easygoing and Effortless
    'yj30vwTGJxSHezdAGsv9',
  ],

  voiceIdsExamples: [
    // James - Husky, Engaging and Bold
    'EkK5I93UQWFDigLMpZcX',
    // John Doe - Deep
    'EiNlNiXeDU1pqqOPrYMO',
    // Adam
    'wBXNqKUATyqu0RtYt25i',
    // Titan - Deep, Bold, and Powerful
    'dtSEyYGNJqjrtBArPCVZ',
    // Tyler – Clear US YouTube Creator Voice
    'rPMkKgdwgIwqv4fXgR6N',
    // Lawrence - Bright and Informative
    'ktkP7Nsj67dw2zcplQYt',
    /* ******************* Female ******************* */
    // Maisie - Friendly Casual Neighbor
    'QtY3JBOUKEB5xzrRfOKc',
    // Allison - Energetic, Clear and Bubbly
    'xctasy8XvGp2cVO9HL9k',
    // Siren - Natural realistic conversational voice
    'eXpIbVcVbLo8ZJQDlDnl',
    // Jessica Anne Bogart - Eloquent Villain
    'flHkNRp1BlvT73UL6gyz',
    // Amelia - Enthusiastic and Expressive
    'ZF6FPAbjXT4488VcRRnw',
    // Katherine - Calm Luxury Narrator
    'NtS6nEHDYMQC9QczMQuq',
    // Edward - British, Dark, Seductive, Low
    'goT3UYdM9bhm0n2lmKQx',
  ],
};
